// @mui
import { RadioGroup } from '@mui/material';

//
import { useSettingsContext } from '../SettingsContext';
import { LayoutIcon, MaskControl, StyledCard, StyledWrap } from '../styles';

// ----------------------------------------------------------------------

const OPTIONS = ['vertical', 'horizontal', 'mini'] as const;

const LayoutOptions = () => {
  const { onChangeLayout, themeLayout } = useSettingsContext();

  return (
    <RadioGroup
      name="themeLayout"
      onChange={onChangeLayout}
      value={themeLayout}
    >
      <StyledWrap sx={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
        {OPTIONS.map((layout) => (
          <StyledCard
            key={layout}
            selected={themeLayout === layout}
            sx={{ height: 56, p: 0.75 }}
          >
            <LayoutIcon layout={layout} />

            <MaskControl value={layout} />
          </StyledCard>
        ))}
      </StyledWrap>
    </RadioGroup>
  );
};

export default LayoutOptions;
